import * as tslib_1 from "tslib";
import * as React from 'react';
import { BaseComponent } from '../../Utilities';
import { CalloutContent } from './CalloutContent';
import { Layer } from '../../Layer';
var Callout = /** @class */ (function (_super) {
    tslib_1.__extends(Callout, _super);
    function Callout(props) {
        return _super.call(this, props) || this;
    }
    Callout.prototype.render = function () {
        var _a = this.props, layerProps = _a.layerProps, rest = tslib_1.__rest(_a, ["layerProps"]);
        var content = React.createElement(CalloutContent, tslib_1.__assign({}, rest));
        return this.props.doNotLayer ? content : React.createElement(Layer, tslib_1.__assign({}, layerProps), content);
    };
    return Callout;
}(BaseComponent));
export { Callout };
//# sourceMappingURL=Callout.js.map